export default function headerSection(titulo){
    return(
        <h2 className="headerSection">
            {titulo}
        </h2>
    )
}